import React, { useEffect, useState } from 'react';
import { Drawer, Form, Input, Select, Button, Space, Divider } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';

const { Option } = Select;

const operatorOptions = [
  'Equals',
  'Add',
  'Remove First',
  'Remove Before First',
  'Remove After First',
  'Remove All',
  'Add At Start',
  'Remove Uncommon',
  'Remove Position',
];

const AssignmentNodeFlowDrawer = ({
  visible,
  onClose,
  nodeData,
  onSave,
  selectedNode,
  setNodeData,
  isEditingMode,
  logbook = "false",
  createRecordData
}) => {
  const [form] = Form.useForm();
  const [fieldValuePairs, setFieldValuePairs] = useState([{ field: '', operator: 'Equals', value: '' }]);
  const [name, setName] = useState('');
  const [apiName, setApiName] = useState('');
  const [description, setDescription] = useState('');
  
  useEffect(() => {
    if (visible && nodeData && Object.keys(nodeData).length > 0) {
        console.log('nodedata:::',nodeData);    
      setName(nodeData?.name || nodeData?.label || '');
      setApiName(nodeData?.apiName || nodeData?.apiname || nodeData?.name || '');
      setDescription(nodeData?.description || '');
  
      // Handle flat parameters object like: { "hi": "gg" }
      if (nodeData.parameters && typeof nodeData.parameters === 'object') {
        const pairs = Object.entries(nodeData.parameters).map(([field, value]) => ({
          field,
          operator: 'Equals', // keep this if UI shows it
          value,
        }));
        setFieldValuePairs(pairs);
      } else {
        setFieldValuePairs([{ field: '', operator: 'Equals', value: '' }]);
      }
    } else {
    //   form.resetFields();
      setName('');
      setApiName('');
      setDescription('');
      setFieldValuePairs([{ field: '', operator: 'Equals', value: '' }]);
    }
  }, [visible]);
  
  const handleAddAssignment = () => {
    setFieldValuePairs([...fieldValuePairs, { field: '', operator: 'Equals', value: '' }]);
  };

  const handleRemoveAssignment = (index) => {
    const updated = [...fieldValuePairs];
    updated.splice(index, 1);
    setFieldValuePairs(updated);
  };

  const handleAssignmentChange = (index, key, value) => {
    const updated = [...fieldValuePairs];
    updated[index][key] = value;
    setFieldValuePairs(updated);
  };

  const handleSubmit = () => {
    form.validateFields().then(() => {
  
      const fields = fieldValuePairs.reduce((acc, { field, value }) => {
        if (field) acc[field] = value || '';
        return acc;
      }, {});
    
      const parameters = {
        ...fields,
      };
    
        const assignData = {
        apiName,
        type: 'assignment',
        description,
        name,
        parameters
      };
      console.log('sending body from drawer..',assignData);
      onSave(selectedNode.id,assignData);
    //   onClose();
    });
  };
  
  return (
    <Drawer
      title="Assignment"
      placement="right"
      width={600}
      zIndex={1002}   // higher than sidebar
      mask={false}
      onClose={onClose}
      open={visible}
      destroyOnClose
      footer={
        <div style={{ textAlign: 'right' }}>
          <Button onClick={onClose} style={{ marginRight: 8 }}>
            Cancel
          </Button>
          <Button onClick={handleSubmit} type="primary">
            Save
          </Button>
        </div>
      }
    >
      <Form layout="vertical">
        {/* Name Input */}
        <Form.Item label="Name" required>
            <Input
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter a name"
            onBlur={() => {
                if (name) {
                const generatedApiName = name
                    .replace(/[^a-zA-Z0-9]/g, '') // Remove special characters
                    .replace(/\s+/g, '') // Remove spaces
                    .trim();
                setApiName(generatedApiName);
                }
            }}
            />
        </Form.Item>

        {/* API Name Input */}
        <Form.Item label="API Name" required>
            <Input
            value={apiName}
            onChange={(e) => setApiName(e.target.value)}
            placeholder="Enter API name"
            disabled
            />
        </Form.Item>

        {/* Description Input */}
        <Form.Item label="Description">
            <Input.TextArea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Enter description"
            rows={3}
            />
        </Form.Item>


        <Divider>Set Variable Values</Divider>

        {fieldValuePairs.map((pair, index) => (
          <Space key={index} align="baseline" style={{ display: 'flex', marginBottom: 8 }}>
            <Input
              placeholder="Variable"
              value={pair.field}
              onChange={(e) => handleAssignmentChange(index, 'field', e.target.value)}
              style={{ width: 180 }}
            />
            <Select
              value={pair.operator}
              onChange={(value) => handleAssignmentChange(index, 'operator', value)}
              style={{ width: 160 }}
            >
              {operatorOptions.map(op => (
                <Option key={op} value={op}>{op}</Option>
              ))}
            </Select>
            <Input
              placeholder="Value"
              value={pair.value}
              onChange={(e) => handleAssignmentChange(index, 'value', e.target.value)}
              style={{ width: 180 }}
            />
            <Button
              type="text"
              icon={<DeleteOutlined />}
              onClick={() => handleRemoveAssignment(index)}
            />
          </Space>
        ))}

        <Button type="dashed" onClick={handleAddAssignment} icon={<PlusOutlined />} block>
          Add Assignment
        </Button>
      </Form>
    </Drawer>
  );
};

export default AssignmentNodeFlowDrawer;
